module.exports = "/_next/static/images/StreamlineAccess-3482e02e260956bc7db833690df5bd3b.webp";